import { userAdminApi } from "../api/userAdminApi";

export const getUsersNames = async (userIds: string) => {
    const users = await userAdminApi.getUsers(userIds);
    return users.map((u) => u.name);
}

export const setUsersNames = async (firmwares: any[]) => {
    let mappedFirmwares = [];
    const promises = [];

    for (let i = 0; i < firmwares.length; i++) {
        const element = firmwares[i];
        const userIds = element.authorizedUsers.join('');
        if (userIds) promises.push(getUsersNames(userIds));
        else promises.push('');
    }
    const res = await Promise.all(promises);

    mappedFirmwares = firmwares.map((f, i) => {
        f.authorizedUserNames = res[i];
        return f;
    });

    return mappedFirmwares;
}
